import React, { useEffect, useRef, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { connect } from "react-redux";
import * as actions from "../redux/actions";
import { Button, styled, Tooltip } from "@mui/material";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import RefreshIcon from '@mui/icons-material/Refresh';
import DownloadIcon from '@mui/icons-material/Download';
import PrintIcon from '@mui/icons-material/Print';
import QRCode from "qrcode";
import MatxLoading from "../components/MatxLoading";
import ReactToPrint from "react-to-print";


const StyledButton = styled(Button)(({ theme }) => ({
    margin: theme.spacing(1),
}));

const ViewTypingCertificate = (props) => {
    const navigate = useNavigate();
    const componentRef = useRef();
    const canvas2Ref = useRef(null);
    const { StudentCourseId, StudentId, print } = useParams();
    // certNo can be passed as a prop when opened from Verify; fallback to params if not provided
    const certNoProp = props?.certNo;

    // State to hold certificate details fetched from API (or from redux)
    const [certDetails, setCertDetails] = useState(null);

    // Dummy certificate data for design purposes
    const certificate = {
        StudentName: "John Doe",
        MotherName: "Sarita",
        Grade: "A Grade",
        Percentage: "68%",
        InternalTestMark: 85,
        VivaMarks: 10,
        OnlineTestMarks: 5,
        ProductName: "Computer Typing Certificate",
        StartDate: "01/04/2025",
        EndDate: "30/06/2025",
        FranchiseName: "Tech Learning Center",
        City: "New York",
        SerialNumber: "TYP001234",
        CertificatePrintDate: "2024-03-20",
        CertificateIssueDate: "2024-03-20",
        StudentProfileUrl: "/assets/images/face-1.jpg", // Using existing demo image
        QrCodeUrls: "https://example.com/verify/TYP001234",
        objectiveMin: 50,
        objectiveMax: 25,
        objectiveObtain: 44,
        emailWritingMax: 5,
        letterWritingMax: 15,
        statementMax: 10,
        passageWritingMax: 20,
        practicalMin: 15,
        passageMin: 10,
        practicalObtain: 27.5,
        passageObtain: 16,
        maxTotal: 100,
        minTotal: 50,
        obtainTotal: 87.5,
        subjectName: "Marathi 30 WPM",
        courseName: "Certificate Course in Computer Basic Typing (CCCBT)"
    };

    const [profileEmpty, setProfileEmpty] = useState(false);
    const [loading, setLoading] = useState(false);
    const [showGrid, setShowGrid] = useState(false); // Toggle for coordinate grid

    // Helper to format numbers by rounding to nearest integer.
    // Always returns a numeric string (no percent sign) for consistent usage.
    const formatNumber = (val) => {
        if (val === null || val === undefined) return '-';
        if (typeof val === 'number') return String(Math.round(val));
        const str = String(val).trim();
        // Remove percent sign and any commas before parsing
        const num = parseFloat(str.replace(/%|,/g, ''));
        if (isNaN(num)) return str; // return original when it isn't a numeric value
        return String(Math.round(num));
    };

    const drawImage2 = async (canvas, image, exam, profile, qrcode, tick) => {
        const ctx = canvas.getContext("2d");

        if (print !== "print") {
            ctx.drawImage(image, 0, 0, canvas.width, canvas.height);
        }
        try {
            ctx.drawImage(profile, 510, 312, 168, 218);
        } catch (error) {
            console.log(error);
        }

        ctx.fillStyle = "#2e";
        ctx.font = "30px FreeSans";
        ctx.textAlign = "center";
        ctx.fillText(
            `${certDetails?.student_name}`,
            600,
            622
        );

        ctx.fillStyle = "#2e";
        ctx.font = "30px FreeSans";
        ctx.textAlign = "left";
        ctx.fillText(
            `${certDetails?.mother_name ?? '-'}`,
            550,
            673
        );

        
        ctx.fillStyle = "#2e";
        ctx.font = "30px FreeSans";
        ctx.textAlign = "left";
        ctx.fillText(
            `${certDetails?.grade}`,
            605,
            794
        );

         ctx.fillStyle = "#2e";
        ctx.font = "30px FreeSans";
        ctx.textAlign = "left";
        ctx.fillText(
            `${(certDetails?.grade == 'F' || !certDetails?.grade) ? 'Failed' : 'Passed'}`,
            460,
            733
        );

        ctx.fillStyle = "#2e";
        ctx.font = "30px FreeSans";
        ctx.textAlign = "center";
        ctx.fillText(
            `${formatNumber(certDetails?.percentage)}%`,
            815,
            790
        );

        ctx.fillStyle = "#2e";
        ctx.font = "18px FreeSans";
        ctx.textAlign = "center";
        ctx.fillText(
            `${certDetails?.start_date ?? '-'}`,
            350,
            940
        );

        ctx.fillStyle = "#2e";
        ctx.font = "18px FreeSans";
        ctx.textAlign = "center";
        ctx.fillText(
            `${certDetails?.end_date ?? '-'}`,
            900,
            941
        );

        ctx.fillStyle = "#2e";
        ctx.font = "18px FreeSans";
        ctx.textAlign = "center";
        ctx.fillText(
            `${formatNumber(certDetails?.objective_max)}`,
            568,
            1094
        );


        ctx.fillStyle = "#2e";
        ctx.font = "18px FreeSans";
        ctx.textAlign = "center";
        ctx.fillText(
            `${formatNumber(certDetails?.objective_min)}`,
            568,
            1140
        );

        ctx.fillStyle = "#2e";
        ctx.font = "18px FreeSans";
        ctx.textAlign = "center";
        ctx.fillText(
            `${formatNumber(certDetails?.objective_obtain)}`,
            568,
            1190
        );

        ctx.fillStyle = "#2e";
        ctx.font = "18px FreeSans";
        ctx.textAlign = "center";
        ctx.fillText(
            `${formatNumber(certDetails?.email_writing_max)}`,
            659,
            1094
        );

        ctx.fillStyle = "#2e";
        ctx.font = "18px FreeSans";
        ctx.textAlign = "center";
        ctx.fillText(
            `${formatNumber(certDetails?.letter_writing_max)}`,
            730,
            1094
        );

        ctx.fillStyle = "#2e";
        ctx.font = "18px FreeSans";
        ctx.textAlign = "center";
        ctx.fillText(
            `${formatNumber(certDetails?.statement_max)}`,
            817,
            1094
        );

        ctx.fillStyle = "#2e";
        ctx.font = "18px FreeSans";
        ctx.textAlign = "center";
        ctx.fillText(
            `${formatNumber(certDetails?.passage_typing_max)}`,
            913,
            1094
        );

        ctx.fillStyle = "#2e";
        ctx.font = "18px FreeSans";
        ctx.textAlign = "center";
        ctx.fillText(
            `${formatNumber(certDetails?.practical_min_avg)}`,
            730,
            1143
        );

        ctx.fillStyle = "#2e";
        ctx.font = "18px FreeSans";
        ctx.textAlign = "center";
        ctx.fillText(
            `${formatNumber(certDetails?.passage_typing_min)}`,
            914,
            1143
        );

        ctx.fillStyle = "#2e";
        ctx.font = "18px FreeSans";
        ctx.textAlign = "center";
        ctx.fillText(
            `${formatNumber(certDetails?.practical_obtain_avg)}`,
            730,
            1190
        );



        ctx.fillStyle = "#2e";
        ctx.font = "18px FreeSans";
        ctx.textAlign = "center";
        ctx.fillText(
            `${formatNumber(certDetails?.passage_typing_obtain)}`,
            913,
            1190
        );


        ctx.fillStyle = "#2e";
        ctx.font = "18px FreeSans";
        ctx.textAlign = "center";
        ctx.fillText(
            `${formatNumber(certDetails?.total_max)}`,
            1020,
            1094
        );


        ctx.fillStyle = "#2e";
        ctx.font = "18px FreeSans";
        ctx.textAlign = "center";
        ctx.fillText(
            `${formatNumber(certDetails?.total_min)}`,
            1020,
            1145
        );

        ctx.fillStyle = "#2e";
        ctx.font = "18px FreeSans";
        ctx.textAlign = "center";
        ctx.fillText(
            `${formatNumber(certDetails?.total_obtain)}`,
            1020,
            1190
        );


        ctx.fillStyle = "#2e";
        ctx.font = "17px FreeSans";
        ctx.textAlign = "left";
        ctx.fillText(
            `${certDetails?.exam_name ?? '-'}`,
            120,
            1142
        );

        ctx.fillStyle = "#2e";
        ctx.font = "bold 24px FreeSans";
        ctx.textAlign = "center";
        ctx.fillText(
            `${certDetails?.exam_name ?? '-'}`,
            600,
            895
        );

        ctx.fillStyle = "#2e";
        ctx.font = "24px FreeSans";
        ctx.textAlign = "center";
        ctx.fillText(
            `${certDetails?.certificate_issue_date ?? '-'}`,
            309,
            1338
        );

        ctx.fillStyle = "#2e";
        ctx.font = "24px FreeSans";
        ctx.textAlign = "left";
        ctx.fillText(
            `${certDetails?.certificate_prefix}/${certDetails?.certificate_number_int}`,
            260,
            1291
        );


        ctx.fillStyle = "#2e";
        ctx.font = "24px FreeSans";
        ctx.textAlign = "left";
        ctx.fillText(
            `${certDetails?.franchise_name ?? '-'}`,
            150,
            1245
        );



       ctx.font = "20px FreeSans";
        ctx.fillText("Document certified by Ajay M", 711, 1330);
        ctx.font = "18px FreeSans";
        ctx.fillText("Digitally signed by Ajay M", 711, 1351);
        ctx.fillText(`Dated:${certDetails?.certificate_issue_date_raw}`, 711, 1372);
        ctx.font = "15px FreeSans";
        ctx.fillText(
            "Digitally signed document, hence does not need signature",
            711,
            1391
        );


        try {
            ctx.drawImage(tick, 880, 1300, 100, 100);
        } catch (error) {
            console.log(error);
        }

        try {
            ctx.drawImage(qrcode, 150, 1375, 100, 100);
        } catch (error) {
            console.log(error);
        }

        // Draw coordinate grid if enabled (helpful for finding coordinates)
        if (showGrid) {
            drawGrid(canvas);
        }
    };

    // If certNo is provided via props (from Verify) or params, fetch certificate via redux action
    useEffect(() => {
        const certNo = certNoProp || (StudentId && StudentCourseId ? `${StudentId}/${StudentCourseId}` : null);
        if (certNo && props.getCertificate) {
            props.getCertificate(certNo);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [certNoProp, StudentId, StudentCourseId]);

    // Update local state when redux certificate prop changes
    useEffect(() => {
        if (props.certificate) {
            setCertDetails(props.certificate);
        }
    }, [props.certificate]);

    // When certDetails is available, render the certificate on canvas
    useEffect(() => {
        if (certDetails) {
            RenderCertificate(certDetails);
        }
    }, [certDetails]);

    const RenderCertificate = async (certificate) => {
        setLoading(true);
        const image2 = new Image();
        image2.src = "/images/Certificate/typing_certificate.jpg";
        const canvas2 = canvas2Ref.current;
        canvas2.width = 1188;
        canvas2.height = 1680;
        await image2.decode().catch(() => {
            // Fallback if certificate background doesn't exist
            console.log("Certificate background not found, using placeholder");
        });

        let profile = new Image();
        profile.src = certDetails?.student_profile_url;
        profile.crossOrigin = "anonymous";
        await profile.decode().catch(() => {
            // Fallback if profile image doesn't exist
            setProfileEmpty(true);
            console.log("Profile image not found");
        });

        let qrcode = new Image();
        await QRCode.toDataURL(`${process.env.REACT_APP_WEBSITE_URL}/#/verify/${certDetails?.certificate_number_int}`).then((data) => {
            qrcode.src = data;
        }).catch(() => {
            console.log("QR code generation failed");
        });
        qrcode.crossOrigin = "anonymous";
        await qrcode.decode().catch(() => {
            console.log("QR code decode failed");
        });

        let tick = new Image();
        tick.src = "/images/Tick-Mark.png";
        tick.crossOrigin = "anonymous";
        await tick.decode().catch(() => {
            console.log("Tick mark image not found");
        });

        setLoading(false);

        drawImage2(canvas2, image2, certificate, profile, qrcode, tick);
    };

    const getCursorPos = (event) => {
        const canvas2 = canvas2Ref.current;
        const rect = canvas2.getBoundingClientRect();

        // Calculate scale factors to account for canvas display size vs actual size
        const scaleX = canvas2.width / rect.width;
        const scaleY = canvas2.height / rect.height;

        // Get actual canvas coordinates
        const x = (event.clientX - rect.left) * scaleX;
        const y = (event.clientY - rect.top) * scaleY;

        // Log coordinates to console for easy copying
        console.log(`📍 Canvas Coordinates: X=${Math.round(x)}, Y=${Math.round(y)}`);
        console.log(`📝 For ctx.fillText: ctx.fillText("Your Text", ${Math.round(x)}, ${Math.round(y)});`);

        // Show coordinates in alert for immediate visibility
        alert(`Coordinates:\nX: ${Math.round(x)}\nY: ${Math.round(y)}\n\nCode:\nctx.fillText("Your Text", ${Math.round(x)}, ${Math.round(y)});`);
    };

    // Function to draw coordinate grid (helpful for precision)
    const drawGrid = (canvas) => {
        const ctx = canvas.getContext("2d");
        const width = canvas.width;
        const height = canvas.height;

        ctx.strokeStyle = "#ff000050"; // Semi-transparent red
        ctx.lineWidth = 1;

        // Draw vertical lines every 50 pixels
        for (let x = 0; x <= width; x += 50) {
            ctx.beginPath();
            ctx.moveTo(x, 0);
            ctx.lineTo(x, height);
            ctx.stroke();

            // Add coordinate labels every 100 pixels
            if (x % 100 === 0) {
                ctx.fillStyle = "#ff0000";
                ctx.font = "12px Arial";
                ctx.fillText(x.toString(), x + 2, 15);
            }
        }

        // Draw horizontal lines every 50 pixels
        for (let y = 0; y <= height; y += 50) {
            ctx.beginPath();
            ctx.moveTo(0, y);
            ctx.lineTo(width, y);
            ctx.stroke();

            // Add coordinate labels every 100 pixels
            if (y % 100 === 0) {
                ctx.fillStyle = "#ff0000";
                ctx.font = "12px Arial";
                ctx.fillText(y.toString(), 2, y - 2);
            }
        }
    };

    const download = () => {
        const imageLink = document.createElement("a");
        const canvas = canvas2Ref.current;
        imageLink.download = `Certificate-${certDetails.student_name}.png`;
        imageLink.href = canvas.toDataURL("image/png", 1);
        imageLink.click();
    };
    return (
        <div style={{ margin: 10 }}>
            <div
                style={{
                    display: "flex",
                    alignItems: "center",
                    margin: 10,
                    marginBottom: 20,
                }}
            >
                <ArrowBackIcon
                    style={{ marginRight: 50, cursor: "pointer" }}
                    onClick={() => navigate(-1)}
                />

                {/* <Tooltip title="hit me if certificate doesn't load properly">
                    <RefreshIcon
                        style={{ marginRight: 50, cursor: "pointer" }}
                        onClick={() => window.location.reload(true)}
                    />
                </Tooltip> */}

                {/* <Tooltip title="Toggle coordinate grid to help find text positions">
                    <Icon
                        style={{
                            marginRight: 50,
                            cursor: "pointer",
                            color: showGrid ? "#1976d2" : "inherit"
                        }}
                        onClick={() => setShowGrid(!showGrid)}
                    >
                        grid_on
                    </Icon>
                </Tooltip> */}
                {print === "print" ? (
                    <ReactToPrint
                        trigger={() => (
                            <StyledButton
                                variant="contained"
                                color="inherit"
                                style={{ margin: 0, marginRight: 20 }}
                            >
                                <PrintIcon style={{ marginRight: 7 }} />
                                Print Certificate
                            </StyledButton>
                        )}
                        content={() => componentRef.current}
                    />
                ) : (
                    <StyledButton
                        variant="contained"
                        color="inherit"
                        style={{ margin: 0, marginRight: 20 }}
                        onClick={download}
                        disabled={profileEmpty}
                    >
                        <DownloadIcon style={{ marginRight: 7 }} />
                        Download Certificate
                    </StyledButton>
                )}
            </div>
            {!certDetails ? (
                <div style={{ minHeight: 400, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <MatxLoading />
                </div>
            ) : (
                <>
                    {loading && <MatxLoading />}
                    <div ref={componentRef}>
                        <canvas
                            style={{ border: "1px solid" }}
                            // onMouseDown={getCursorPos}
                            ref={canvas2Ref}
                            id="canvas"
                        ></canvas>
                    </div>
                </>
            )}
        </div>
    );
};

const mapStateToProps = (state) => {
    return {
        certificate: state.exam.studentCertificate,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getCertificate: (certno) => dispatch(actions.GetStudentCertificate(certno)),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(ViewTypingCertificate);
